var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal", class: { "is-active": _vm.isVisible } },
    [
      _c("div", { staticClass: "modal-background", on: { click: _vm.close } }),
      _c("div", { staticClass: "modal-content", class: `modal-${_vm.size}` }, [
        _c("div", { staticClass: "modal-inner-wrapper" }, [
          _c("a", { attrs: { id: "modalclose" }, on: { click: _vm.close } }, [
            _c("i", { staticClass: "fas fa-times" })
          ]),
          _c("h1", [_vm._v("Comp Details")]),
          _vm.comp
            ? _c("div", [
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("First Name")
                        ]),
                        _c("p", { staticClass: "control" }, [
                          _vm._v(_vm._s(_vm.comp.firstName))
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Last Name")
                        ]),
                        _c("p", { staticClass: "control" }, [
                          _vm._v(_vm._s(_vm.comp.lastName))
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Email")
                        ]),
                        _c("p", { staticClass: "control" }, [
                          _vm._v(_vm._s(_vm.comp.email || "N/A"))
                        ])
                      ])
                    ])
                  ]),
                  _vm.comp.createdByName || _vm.comp.createdAt
                    ? _c("div", { staticClass: "columns" }, [
                        _vm.comp.createdByName
                          ? _c("div", { staticClass: "column" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Created By")
                                ]),
                                _c("p", { staticClass: "control" }, [
                                  _vm._v(_vm._s(_vm.comp.createdByName))
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm.comp.createdAt
                          ? _c("div", { staticClass: "column" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Created At")
                                ]),
                                _c("p", { staticClass: "control" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatTimestamp(_vm.comp.createdAt)
                                    )
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.comp.discountCode
                    ? _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Note")
                            ]),
                            _c("p", { staticClass: "control" }, [
                              _vm._v(_vm._s(_vm.comp.discountCode))
                            ])
                          ])
                        ])
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "section" }, [
                  _c("h4", [_vm._v("Comp Summary")]),
                  _c(
                    "table",
                    { staticClass: "table is-fullwidth line-items-table" },
                    [
                      _vm._m(0),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [_vm._v(_vm._s(_vm.formatDate(_vm.date)))]),
                          _c("td", [_vm._v(_vm._s(_vm.eventTitle))]),
                          _c("td", [
                            _vm._v(_vm._s(_vm.comp.tierName || "Comp"))
                          ]),
                          _c("td", [_vm._v(_vm._s(_vm.comp.quantity))]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v("$0.00")
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v("$0.00")
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              ])
            : _c("div", { staticClass: "has-text-centered" }, [
                _c("p", [_vm._v("No comp details available.")])
              ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Date")]),
        _c("th", [_vm._v("Event")]),
        _c("th", [_vm._v("Description")]),
        _c("th", [_vm._v("Quantity")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Price")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Total")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }